var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYAxis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_416_7927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68726 2.75C4.68726 2.33579 4.35147 2 3.93726 2C3.52304 2 3.18726 2.33579 3.18726 2.75V21.25C3.18726 21.6642 3.52304 22 3.93726 22H22.1873C22.6015 22 22.9373 21.6642 22.9373 21.25C22.9373 20.8358 22.6015 20.5 22.1873 20.5H4.68726V2.75Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1873 8L12.9103 11.5871L15.6334 8",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9104 11.5869V14.3769",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.211725 5.18714C0.056006 5.03142 0.0546528 4.78031 0.208703 4.62626L3.55588 1.2791C3.70993 1.12505 3.96104 1.12641 4.11676 1.28213L7.5002 4.66557C7.65592 4.82129 7.65728 5.0724 7.50323 5.22645C7.34918 5.3805 7.09806 5.37915 6.94234 5.22343L4.2396 2.52069L4.28079 10.1634C4.28197 10.3825 4.10536 10.5591 3.88632 10.5579C3.66728 10.5567 3.48876 10.3782 3.48758 10.1591L3.44638 2.51641L0.77261 5.19017C0.61856 5.34422 0.367443 5.34286 0.211725 5.18714Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_7927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYAxis);
export default __webpack_public_path__ + "static/media/y-axis.ec3abdb6.svg";
export { ForwardRef as ReactComponent };